import React from "react";
import "./welcome.scss";

interface WelcomeProps {
    text: string
}

export const Welcome: React.FC<WelcomeProps> = ({ text }) => {
    return (
        <div className="welcome-text">{text}</div>
    );
};
